module.exports = __webpack_public_path__ + "assets/img/9.194515a5.png";